<template>
    <SeoHead :seo="seo" />
    <main-layout>
        <div class="advanced-stats-page">
            <PageHeader title="Для продвинутых">
                <SeasonSelect
                    :model-value="appliedFilters.season_ids"
                    :seasons="seasons"
                    @change="onSeasonChange"
                />
                <div class="advanced-stats-page__count">{{ filteredPlayers.length }} игроков</div>
            </PageHeader>

            <AdvancedStatsFilters
                :seasons="seasons"
                :teams="teams"
                :positions="positions"
                :matches="matches"
                :applied-filters="appliedFilters"
                @apply="onApply"
                @reset="onApply"
                @search-change="searchQuery = $event"
            />

            <AdvancedStatsTable :players="filteredPlayers" />
        </div>
    </main-layout>
</template>

<script setup>
import { computed, ref } from 'vue';
import { router } from '@inertiajs/vue3';
import SeoHead from '@/Components/SeoHead.vue';
import MainLayout from '@/components/layout/MainLayout.vue';
import PageHeader from '@/components/layout/PageHeader.vue';
import AdvancedStatsFilters from '@/components/advanced-stats/AdvancedStatsFilters.vue';
import AdvancedStatsTable from '@/components/advanced-stats/AdvancedStatsTable.vue';
import SeasonSelect from '@/components/filters/SeasonSelect.vue';
import { buildAppliedQueryParams } from '@/utils/skillQualityConfig';

const props = defineProps({
    seo: { type: Object, default: null },
    seasons: { type: Array, default: () => [] },
    teams: { type: Array, default: () => [] },
    positions: { type: Array, default: () => [] },
    matches: { type: Array, default: () => [] },
    appliedFilters: { type: Object, default: () => ({}) },
    players: { type: Array, default: () => [] },
    competitions: { type: Array, default: () => [] },
});

const searchQuery = ref('');

const filteredPlayers = computed(() => {
    const query = searchQuery.value.trim().toLowerCase();
    if (!query) {
        return props.players;
    }

    return props.players.filter((player) => player.name.toLowerCase().includes(query));
});

function onApply(filters) {
    router.get('/stats/advanced', buildAppliedQueryParams(filters), {
        preserveScroll: true,
        preserveState: false,
    });
}

function onSeasonChange(seasonIds) {
    onApply({
        ...props.appliedFilters,
        season_ids: seasonIds,
        team_ids: [],
        match_ids: [],
    });
}
</script>
